import { cn } from "@/lib/utils";
import { RichTextField } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import { Minus, Plus } from "lucide-react";

type AccordianProps = {
  qnas: {
    question: string;
    answers: {
      question: string;
      answer: RichTextField;
    }[];
  }[];
  className?: string;
};

const Accordian = ({ qnas, className }: AccordianProps) => {
  return (
    <div className={cn("w-full max-w-[24.625rem] space-y-5 antialiased", className)}>
      {qnas &&
        qnas.length >= 1 &&
        qnas.map(({ question, answers }, index) => (
          <details
            key={index + 1}
            className={cn(
              "bg-[#FBF9F899] text-dark-primary w-full min-w-full rounded-md",
              "group transition-all duration-300"
            )}
          >
            <summary
              className={cn(
                "focus-visible:ring-pink-primary/60 w-full cursor-pointer p-4 text-base font-semibold break-words whitespace-pre-wrap outline-none focus-visible:ring-[3px]",
                "flex list-none items-center justify-between gap-2"
              )}
            >
              {question}
              <Plus aria-hidden="true" className="size-4.5 shrink-0 group-open:hidden" />
              <Minus aria-hidden="true" className="hidden size-4.5 shrink-0 group-open:block" />
            </summary>
            {answers && answers.length >= 1 && (
              <div className="mx-4 space-y-2.5 border-t border-neutral-300 pt-2.5 pb-4 text-base">
                {answers.map(({ question, answer }, i) => (
                  <div key={i} className="space-y-2.5 break-words whitespace-pre-wrap">
                    {question && <span className="inline-block">{question}</span>}
                    <div className="text-sm">
                      <PrismicRichText field={answer} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </details>
        ))}
    </div>
  );
};

export default Accordian;
